export default function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, Math.max(ms, 0)))
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/util/timeout.js